import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'characterCount'
})
export class CharacterCountPipe implements PipeTransform {
  transform(value: string, limit: number) {
    return `${value?.length || 0} characters out of ${limit}`;
  }
}
